import React, { useState } from "react";
import queryString from 'query-string';

import BulkShareModal from '@components/show_page/bulk_actions/BulkShareModal';

const defaultModalState = queryString.parse(window.location.search).show_edit_share_mode === "true";

function ShareManifestEdit({ selectedAssetKeys }) {
  const [openModal, setOpenModal] = useState(defaultModalState);

  return (
    <>
      <div className="s-share-manifest-edit-container no-print">
        <button
          className="share-manifest-edit-button"
          onClick={() => setOpenModal(!openModal)}
          type="button"
        >
          <span className="bff-edit" />
          {t('Edit share link')}
        </button>
        {openModal && (
          <BulkShareModal
            closeModal={() => setOpenModal(false)}
            selectedAssetKeys={new Set(selectedAssetKeys)}
          />
        )}
      </div>
    </>
  );
}

export default ShareManifestEdit;
